'use strict';

exports.__esModule = true;
exports.default = cloneComponent;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneComponent(object) {
  if (!_lodash2.default.isObject(object) || !object) {
    return object;
  }

  var newObject = void 0;

  if (Array.isArray(object)) {
    newObject = [];
    for (var i = 0; i < object.length; i++) {
      newObject[i] = cloneComponent(object[i]);
    }
  } else {
    newObject = {};

    for (var property in object) {
      if (object.hasOwnProperty(property)) {
        newObject[property] = cloneComponent(object[property]);
      }
    }
  }

  return newObject;
}
//# sourceMappingURL=cloneComponent.js.map